import Axios from 'axios'

const ServiceURL = process.env.VUE_APP_SERVICEURL

export default {
    name: 'selections',
    state: {
        spesifikasiProduk: [],
        sertifikatQms: [],
        sertifikatUsaha: [],
        analisaResiko: []
    },
    getters: {
        getSpesifikasiProduk: state => {
            return state.spesifikasiProduk
        },
        getSertifikatQms: state => {
            return state.sertifikatQms
        },
        getSertifikatUsaha: state => {
            return state.sertifikatUsaha
        },
        getAnalisaResiko: state => {
            return state.analisaResiko
        }
    },
    mutations: {
        ADD_SPESIFIKASI_PRODUK: (state, payload) => {
            state.spesifikasiProduk = payload
        },
        ADD_SERTIFIKAT_QMS: (state, payload) => {
            state.sertifikatQms = payload
        },
        ADD_SERTIFIKAT_USAHA: (state, payload) => {
            state.sertifikatUsaha = payload
        },
        ADD_ANALISA_RESIKO: (state, payload) => {
            state.analisaResiko = payload
        }
    },
    actions: {
        async Fetch_Spesifikasi_Produk(store) {
            return await Axios({
                method: "get",
                url: ServiceURL + "suplier/getSpesifikasiProduk",
                auth: {
                    username: store.rootState.user.auth.username,
                    password: store.rootState.user.auth.password
                },
                headers: {
                    'X-API-KEY': store.rootState.user.auth.apikey
                }
            }).then(response => {
                store.commit('ADD_SPESIFIKASI_PRODUK', response.data.data);
            }).catch(err => {
                return err
            });
        },
        async Fetch_Sertifikat_Qms(store) {
            return await Axios({
                method: "get",
                url: ServiceURL + "suplier/getSertifikatQms",
                auth: {
                    username: store.rootState.user.auth.username,
                    password: store.rootState.user.auth.password
                },
                headers: {
                    'X-API-KEY': store.rootState.user.auth.apikey
                }
            }).then(response => {
                store.commit('ADD_SERTIFIKAT_QMS', response.data.data);
            }).catch(err => {
                return err
            });
        },
        async Fetch_Sertifikat_Usaha(store) {
            return await Axios({
                method: "get",
                url: ServiceURL + "suplier/getSertifikatUsaha",
                auth: {
                    username: store.rootState.user.auth.username,
                    password: store.rootState.user.auth.password
                },
                headers: {
                    'X-API-KEY': store.rootState.user.auth.apikey
                }
            }).then(response => {
                store.commit('ADD_SERTIFIKAT_USAHA', response.data.data);
            }).catch(err => {
                return err
            });
        },
        async Fetch_Analisa_Resiko(store) {
            return await Axios({
                method: "get",
                url: ServiceURL + "suplier/getAnalisisRisiko",
                auth: {
                    username: store.rootState.user.auth.username,
                    password: store.rootState.user.auth.password
                },
                headers: {
                    'X-API-KEY': store.rootState.user.auth.apikey
                }
            }).then(response => {
                store.commit('ADD_ANALISA_RESIKO', response.data.data);
            }).catch(err => {
                return err
            });
        },
    }
}